import { useState, useEffect } from "react";

const useCountdown = (initialSeconds = 30) => {
  const [countdown, setCountdown] = useState(initialSeconds);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  const reset = () => setCountdown(initialSeconds);

  return [countdown, reset];
};

export default useCountdown;
